import { detect } from 'detect-browser';

const browser = detect();

if (browser) {
    document.body.classList.add(browser.name);
}
